$(document).ready(function() {
  $("form.filters")
    .find("select")
    .each(function(index, element) {
      $(this).change(function() {
        $("form.filters").submit();
      });
    });
});
